const Permissions = {
  READ: 'Read',
  EDIT: 'Edit',
  CREATE: 'Create',
  DELETE: 'Delete',
  ALL: 'All',
};
const PermissionsV2 = {
  MYREPORTSQUALITYANDUTLISATION: 'My Reports - Quality and Utilization',
  MYREPORTSSURGICALCAPACITY: 'My Reports - Surgical Capacity',
  MYREPORTSSURGICALCOST: 'My Reports - Surgical Cost',
  MYREPORTSAMBULATORY: 'My Reports - Ambulatory QPS',
  SHAREDREPORTSSURGICALCOST: 'Shared Reports - Surgical Cost',
  SHAREDREPORTSQUALITYANDUTLISATION: 'Shared Reports - Quality and Utilization',
  SHAREDREPORTSSURGICALCAPACITY: 'Shared Reports - Surgical Capacity',
  SHAREDREPORTSAMBULATORY: 'Shared Reports - Ambulatory QPS',
  CANNEDREPORTSQUALITYANDUTLISATION: 'Canned Report - Quality and Utilization',
  CANNEDREPORTSSURGICALCAPACITY: 'Canned Report - Surgical Capacity',
  CANNEDREPORTSSURGICALCOST: 'Canned Report - Surgical Cost',
  CANNEDREPORTSAMBULATORY: 'Canned Report - Ambulatory QPS',
};
const AdvancedReportingTemplateModules = [
  'Hospital Quality',
  'Hospital Utilization',
  'Surgical Cost',
  'Surgical Capacity',
  'Ambulatory Quality',
];

export default Permissions;

export { AdvancedReportingTemplateModules, PermissionsV2 };
